import axios from "axios";
import {EventBus} from "../../event-bus";
import PaginationDetailsModel from "./models/PaginationDetailsModel";

const FILTER_MODE_ACCOUNT = 'account';
const FILTER_MODE_ASSIGNED = 'assigned';

export default {
  namespaced: true,
  state: {
    showReferencesMode: FILTER_MODE_ACCOUNT,
    loading: false,
    selectedAccount: undefined,
    showingReference: undefined,
    showReference: false,
    paginationDetails: new PaginationDetailsModel(
      undefined,
      undefined,
      undefined,
      {
        'url': "",
        'page': 1
      },
      {
        'url': "",
        'page': 1
      },
      {
        'url': "",
        'page': ""
      },
      {
        'url': "",
        'page': ""
      },
      {
        'url': "",
        'page': ""
      }
    ),
    references: [],
    editingReference: undefined,
    searchTerm: '',
    referenceDetailsModal: {
      mode: 'create',
      show: false,
      referenceId: undefined,
      name: '',
      details: '',
      is_private: false,
      account_id: false,
    },
    stats: {
      'total': 1,
      'shared': 1,
      'private': 1,
    }
  },
  mutations: {
    setLoading (state, loading) {
      if (loading) {
        EventBus.$emit('loader:show');
      }
      else {
        EventBus.$emit('loader:hide');
      }
      state.loading = loading;
    },
    setReferences (state, references) {
      state.references = references;
    },
    setSearchTerm (state, term) {
      state.searchTerm = term;
    },
    appendReference (state, reference) {
      state.references = [reference, ...state.references];
    },
    setAccount (state, account_id) {
      state.account_id = account_id;
    },
    setStats (state, stats) {
      state.stats = stats;
    },
    updateReferenceModalShow (state, value) {
      state.referenceDetailsModal['show'] = value;
    },
    updateReferenceModalReferenceId (state, value) {
      state.referenceDetailsModal['referenceId'] = value;
    },
    updateReferenceModalName (state, value) {
      state.referenceDetailsModal['name'] = value;
    },
    updateReferenceModalDetails (state, value) {
      state.referenceDetailsModal['details'] = value;
    },
    updateReferenceModalIsPrivate (state, value) {
      state.referenceDetailsModal['is_private'] = value;
    },
    updateReferenceModalAccountId (state, value) {
      state.referenceDetailsModal['account_id'] = value;
    },
    updateReferenceModalMode (state, value) {
      state.referenceDetailsModal['mode'] = value;
    },
    setEditingReference (state, reference) {
      state.editingReference = reference;
    },
    updateReference (state, updatedReference) {
      for (const [key, ref] of Object.entries(state.references)) {
        if (ref.id === updatedReference.referenceId) {
          ref.name = updatedReference.name;
          ref.details_html = updatedReference.details;
          ref.is_private = updatedReference.is_private;
          state.references[key] = ref;
        }
      }
    },
    clearReferenceModal (state) {
      state.referenceDetailsModal['mode'] = 'create';
      state.referenceDetailsModal['referenceId'] = undefined;
      state.referenceDetailsModal['details'] = '';
      state.referenceDetailsModal['name'] = '';
      state.referenceDetailsModal['show'] = false;
      state.referenceDetailsModal['is_private'] = false;
      state.editingReference = false;
    },
    // todo make reusable module store for pagination details
    updatePaginationDetails (state, details) {
      const {from, to, total} = details;
      state.paginationDetails.from = from;
      state.paginationDetails.to = to;
      state.paginationDetails.to = to;
      state.paginationDetails.total = total;
    },
    setNextPage (state, page) {
      state.paginationDetails.nextPage = page;
    },
    setCurrentPage (state, page) {
      state.paginationDetails.currentPage = page;
    },
    setFirstPage (state, page) {
      state.paginationDetails.firstPage = page;
    },
    setLastPage (state, page) {
      state.paginationDetails.lastPage = page;
    },
    setPreviousPage (state, page) {
      state.paginationDetails.previousPage = page;
    },
    setSelectedAccount (state, account) {
      state.selectedAccount = account;
    },
    setShowReferencesMode (state, referenceMode) {
      state.showReferencesMode = referenceMode;
    },
    setViewReference (state, reference) {
      state.showingReference = reference;
      state.showReference = Boolean(reference);
    },
  },
  getters: {
    requestUrl (state) {
      if (state.showReferencesMode === FILTER_MODE_ACCOUNT) {
        const url = new URL(window.location.origin + '/references/account');
        if (state.searchTerm) url.searchParams.append("search_term", state.searchTerm);
        url.searchParams.append("account_id", state.selectedAccount.id);
        url.searchParams.append("page", state.paginationDetails.currentPage.page);
        return url.href;
      }
      
      if (state.showReferencesMode === FILTER_MODE_ASSIGNED) {
        const url = new URL(window.location.origin + '/references/assigned');
        if (state.searchTerm) url.searchParams.append("search_term", state.searchTerm);
        url.searchParams.append("page", state.paginationDetails.currentPage.page);
        return url.href;
      }
    }
  },
  actions: {
    async fetchReferences ({commit, getters}, pagedUrl = undefined) {
      commit('setLoading', true);
      if (!pagedUrl) {
        pagedUrl = getters.requestUrl;
      }
      return axios.get(pagedUrl)
        .then(res => {
            const {
              data,
              next_page_url,
              prev_page_url,
              last_page,
              first_page_url,
              last_page_url,
              current_page,
              to,
              from,
              total
            } = res.data.references;
            commit('setNextPage', {
              page: undefined, //unused
              url: next_page_url
            });
            commit('setCurrentPage', {
              url: undefined, //unused
              page: current_page
            });
            commit('setFirstPage', {
              url: first_page_url,
              page: 1
            });
            commit('setLastPage', {
              url: last_page_url,
              page: last_page
            });
            commit('setPreviousPage', {
              url: prev_page_url,
              page: undefined //unused
            });
            commit('updatePaginationDetails', {
              from,
              to,
              total
            });
            commit('setReferences', data);
            commit('setStats', res.data.stats);
            commit('setLoading', false);
          }
        ).catch((e) => {
          console.log(e);
          commit('setLoading', false);
        });
    },
    async postReference ({dispatch, state, commit, getters}, user_id) {
      commit('setLoading', true);
      return axios.post('/references', {
        "name": state.referenceDetailsModal.name,
        "account_id": state.selectedAccount.id,
        "user_id": user_id,
        "details_html": state.referenceDetailsModal.details,
        "is_private": state.referenceDetailsModal.is_private,
      })
        .then(() => {
            commit('setLoading', false);
            commit('setSearchTerm', '');
            commit('updateReferenceModalShow', false);
            commit('clearReferenceModal');
            dispatch('fetchReferences', getters.requestUrl);
          }
        ).catch(() => {
          commit('setLoading', false);
        });
    },
    async patchReference ({dispatch, state, commit, getters}, updatedData) {
      commit('setLoading', true);
      const referenceId = updatedData.reference_id;
      delete updatedData.reference_id;
      return axios.patch(`/references/${referenceId}`, updatedData)
        .then(() => {
            commit('setLoading', false);
            commit('updateReferenceModalShow', false);
            commit('setSearchTerm', '');
            const updatedReference = state.referenceDetailsModal;
            commit('updateReference', updatedReference);
            commit('clearReferenceModal');
            dispatch('fetchReferences', getters.requestUrl);
          }
        ).catch(() => {
          commit('setLoading', false);
        });
    },
    async deleteReference ({commit, dispatch, getters}, reference_id) {
      commit('setLoading', true);
      return axios.delete(`/references/${reference_id}`)
        .then(() => {
            commit('setLoading', false);
            commit('updateReferenceModalShow', false);
            dispatch('fetchReferences', getters.requestUrl);
          }
        ).catch(() => {
          commit('setLoading', false);
        });
    },
  },
};
